import { createAction } from 'redux-actions';
import * as types from './types';

export const nextButtonClicked = createAction(types.NEXT_BUTTON_CLICKED, currentPage => ({
  currentPage,
}));
